import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {KTSVG, toAbsoluteUrl} from '../../helpers'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {purchaseProposalDelete} from '../../redux/slices/purchase.slice'
import {
  DeleteModal,
  DataTables,
  PurchaceProposalModal,
  KTCard,
  KTCardHeader,
  KTCardBody,
  PurchaceProposalApproveModal,
} from '..'

const PurchaseProposal = ({data, id, canApprove}) => {
  const intl = useIntl()
  const [deleteId, setDeleteId] = useState()
  const [show, setShow] = useState(false)
  const [showPurchaseProposalModal, setShowPurchaseProposalModal] = useState(false)
  const [showApproveModal, setShowApproveModal] = useState(false)
  const [approveId, setApproveId] = useState()
  const dispatch = useDispatch()

  const handleClickDelete = (id) => {
    setDeleteId(id)
    setShow(true)
  }

  const handleClickApprove = (id) => {
    setApproveId(String(id))
    setShowApproveModal(true)
  }

  const handleDelete = () => {
    dispatch(purchaseProposalDelete({Id: deleteId}))
    setShow(false)
  }

  return (
    <>
      <KTCard>
        <KTCardHeader className='p-0'>
          <div className='card-toolbar'>
            <button
              className='btn btn-sm btn-light-success'
              onClick={() => setShowPurchaseProposalModal(true)}
            >
              <KTSVG path='/images/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              {intl.formatMessage({id: 'BUTTON.PURCHASEPROPOSAL.ADD'})}
            </button>
          </div>
        </KTCardHeader>
        <KTCardBody className='p-0 pt-5'>
          {data && data?.length > 0 && (
            <DataTables
              columns={[
                {
                  title: intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.NAME'}),
                  prop: 'name',
                  isSortable: true,
                  isFilterable: true,
                },
                {
                  title: intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.COMPANYNAME'}),
                  prop: 'companyName',
                  isSortable: true,
                  isFilterable: true,
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PURCHASEPROPOSALSTATUSNAME',
                  }),
                  prop: 'purchaseProposalStatusName',
                  isSortable: true,
                  isFilterable: true,
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TRANSPORTATION',
                  }),
                  prop: 'transportation',
                  isSortable: true,
                  isFilterable: true,
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PAYMENTDETAIL',
                  }),
                  prop: 'paymentDetail',
                  isSortable: true,
                  isFilterable: true,
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.DELIVERYTIME',
                  }),
                  prop: 'deliveryTime',
                  isSortable: true,
                  isFilterable: true,
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.BRAND',
                  }),
                  prop: 'brand',
                  isSortable: true,
                  isFilterable: true,
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TSEFILE',
                  }),
                  prop: 'tseFileUrl',
                  cell: (row) => {
                    if (!row.tseFileUrl) return false

                    return (
                      <a
                        href={row.tseFileUrl}
                        target='_blank'
                        rel='noreferrer'
                        className='d-flex align-items-center'
                      >
                        <div className='symbol symbol-30px me-2'>
                          <span className='symbol-label'>
                            <img
                              src={toAbsoluteUrl('/images/icons/duotune/files/folder-document.svg')}
                              className='h-50 align-self-center'
                              alt=''
                            />
                          </span>
                        </div>
                        <div className='flex-grow-1'>
                          <div className='text-dark fw-bold text-hover-primary fs-6'>
                            {intl.formatMessage({
                              id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TSEFILE',
                            })}
                          </div>
                        </div>
                      </a>
                    )
                  },
                },
                {
                  title: intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PRODUCTTOTALPRICE'}),
                  prop: 'productTotalPrice',
                  cell: (row) =>
                    intl.formatNumber(row.productTotalPrice, {style: 'currency', currency: 'try', minimumFractionDigits: 2, maximumFractionDigits: 4}),
                  isSortable: true,
                  isFilterable: true,
                  alignment: {
                    horizontal: 'right',
                  },
                },
                {
                  title: intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.LABORTOTALPRICE'}),
                  prop: 'laborTotalPrice',
                  cell: (row) =>
                    intl.formatNumber(row.laborTotalPrice, {style: 'currency', currency: 'try', minimumFractionDigits: 2, maximumFractionDigits: 4}),
                  isSortable: true,
                  isFilterable: true,
                  alignment: {
                    horizontal: 'right',
                  },
                },
                {
                  title: intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TOTALPRICE'}),
                  prop: 'totalPrice',
                  cell: (row) =>
                    intl.formatNumber(row.totalPrice, {style: 'currency', currency: 'try', minimumFractionDigits: 2, maximumFractionDigits: 4}),
                  isSortable: true,
                  isFilterable: true,
                  alignment: {
                    horizontal: 'right',
                  },
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.TOTALPRICEWITHTAX',
                  }),
                  prop: 'totalPriceWithTax',
                  cell: (row) =>
                    intl.formatNumber(row.totalPriceWithTax, {style: 'currency', currency: 'try', minimumFractionDigits: 2, maximumFractionDigits: 4}),
                  isSortable: true,
                  isFilterable: true,
                  alignment: {
                    horizontal: 'right',
                  },
                },
                {
                  title: intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PROPOSALFILEURL',
                  }),
                  prop: 'proposalFileUrl',
                  cell: (row) => {
                    if (!row.proposalFileUrl) return false

                    return (
                      <a
                        href={row.proposalFileUrl}
                        target='_blank'
                        rel='noreferrer'
                        className='d-flex align-items-center'
                      >
                        <div className='symbol symbol-30px me-2'>
                          <span className='symbol-label'>
                            <img
                              src={toAbsoluteUrl('/images/icons/duotune/files/folder-document.svg')}
                              className='h-50 align-self-center'
                              alt=''
                            />
                          </span>
                        </div>
                        <div className='flex-grow-1'>
                          <div className='text-dark fw-bold text-hover-primary fs-6'>
                            {intl.formatMessage({
                              id: 'REQUEST.GET.PURCHASEPROPOSALITEMS.PROPOSALFILEURL',
                            })}
                          </div>
                        </div>
                      </a>
                    )
                  },
                },
                {
                  title: '',
                  prop: 'id',
                  cell: (row) => {
                    return (
                      <div className='d-flex align-items-center'>
                        {canApprove && (
                          <button
                            type='button'
                            className='btn btn-sm btn-icon btn-active-color-primary'
                            onClick={() => handleClickApprove(row.id)}
                          >
                            <KTSVG
                              path='/images/icons/duotune/general/gen037.svg'
                              className='svg-icon-2'
                            />
                          </button>
                        )}

                        <button
                          type='button'
                          className='btn btn-sm btn-icon btn-active-color-primary'
                          onClick={() => handleClickDelete(row.id)}
                        >
                          <KTSVG
                            path='/images/icons/duotune/general/gen027.svg'
                            className='svg-icon-2'
                          />
                        </button>
                      </div>
                    )
                  },
                },
              ]}
              data={data}
              exportTitle={intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALITEMS'})}
            />
          )}
        </KTCardBody>
      </KTCard>

      <DeleteModal onClick={handleDelete} onOpen={show} onClose={() => setShow(false)} />

      <PurchaceProposalModal
        onOpen={showPurchaseProposalModal}
        onClose={() => setShowPurchaseProposalModal(false)}
        data={data}
        id={id}
      />

      <PurchaceProposalApproveModal
        onOpen={showApproveModal}
        onClose={() => setShowApproveModal(false)}
        id={id}
        approveId={approveId}
      />
    </>
  )
}

PurchaseProposal.propTypes = {
  collapse: PropTypes.bool,
  SourceId: PropTypes.number,
  SourceTypeId: PropTypes.number,
}

export {PurchaseProposal}
